module.exports = __webpack_public_path__ + "static/img/indexQRcode.35f2966.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/image/index/indexQRcode.jpg
// module id = nrLs
// module chunks = 8